import React from 'react';
var GTM_ID = 'GTM-PG465H';
var GTMNoScript = function GTMNoScript() {
  return /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement("iframe", {
    height: "0",
    src: "https://www.googletagmanager.com/ns.html?id=".concat(GTM_ID),
    style: {
      display: 'none',
      visibility: 'hidden'
    },
    title: "Google Tag Manager",
    width: "0"
  }));
};
var GTMScript = function GTMScript() {
  var defer = false;
  return /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n      ".concat(defer ? 'j.defer=true;' : 'j.async=true;', "\n      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer','").concat(GTM_ID, "');\n    ")
    }
  });
};
export var GTM = function GTM() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GTMScript, null), /*#__PURE__*/React.createElement(GTMNoScript, null));
};